// src/components/Comments/index.jsx
// 댓글 API 호출 및 상태 관리 – ‘삭제’는 항상 소프트 삭제만 실행

import { useEffect, useState, useCallback } from 'react';
import {
  fetchComments,
  addComment,
  updateComment,
  softDeleteComment,   // ✅ 항상 소프트 삭제만 사용
  replyToComment,
  toggleCommentLike,
} from '../../api/comments';

import CommentList from './CommentList';
import CommentForm from './CommentForm';
import { Box, Typography } from '@mui/material';
import { useUser } from '../../contexts/UserContext';   // ✅ 추가

const Comments = ({ postId, postAuthorId, onReport }) => {
  const [comments, setComments] = useState([]);
  const { refreshUserInfo } = useUser();               // ✅ 추가

  /* ── 댓글 목록 로드 ─────────────────────────────── */
  const loadComments = useCallback(() => {
    fetchComments(postId).then(res => {
      const asc = Array.isArray(res.data.comments)
        ? [...res.data.comments].reverse()         // 최신 → 오래된 순 변환
        : [];
      setComments(asc);
    });
  }, [postId]);

  useEffect(() => {
    loadComments();
  }, [loadComments]);

  /* ── CRUD 핸들러 ───────────────────────────────── */
  const handleAddComment = content =>
    addComment(postId, content).then(() => {
      loadComments();
      refreshUserInfo();                            // ← 포인트 즉시 반영
    });

  const handleUpdateComment = (commentId, content) =>
    updateComment(commentId, content).then(loadComments);

  // ✅ 항상 소프트 삭제
  const handleDeleteComment = async (commentId, memo = '') => {
    await softDeleteComment(commentId, memo);
    loadComments();
  };

  const handleReplyComment = (commentId, content) =>
    replyToComment(postId, commentId, content).then(() => {
      loadComments();
      refreshUserInfo();                            // ← 대댓글도 포인트 반영
    });

  const handleToggleLike = commentId =>
    toggleCommentLike(commentId).then(loadComments);

  /* ── 렌더 ──────────────────────────────────────── */
  return (
    <Box
      sx={{
        width: '100%',           // 📌 컨테이너 가득 채우기 
        p: { xs: 1.5, sm: 2 },   //    모바일 1.5(12 px) · 데스크톱 2(16 px) 
      }}
    >
      {/* 댓글 작성창 */}
      <CommentForm onSubmit={handleAddComment} />

      {/* 댓글 개수 표시 */}
      <Typography
        variant="h6"
        sx={{
          mt: 2,
          mb: 1,
          textAlign: 'left',
          fontSize: { xs: '1rem', sm: '1.25rem' },
        }}
      >
        댓글 ({comments.length})
      </Typography>

      {/* 댓글 리스트 */}
      <CommentList
        comments={comments}
        postAuthorId={postAuthorId}
        onUpdate={handleUpdateComment}
        onDelete={handleDeleteComment}
        onReply={handleReplyComment}
        onReport={onReport}
        onLike={handleToggleLike}
      />
    </Box>
  );
};

export default Comments;
